<template>
  <div
    class="splash-loading"
    :style="{
      backgroundColor,
    }"
  >
    <img class="logo" src="/images/logo.svg" />
  </div>
</template>

<script>
// const backgroundColors = ['#CBFB01', '#7CE1D3', '#FF6A5C']
const backgroundColors = ['#CBFB01']

export default {
  name: 'SplashLoading',

  computed: {
    backgroundColor() {
      const backgroundColor =
        backgroundColors[Math.floor(Math.random() * backgroundColors.length)]

      return backgroundColor
    },
  },

  methods: {
    async startAnimation() {
      return this
    },

    async endAnimation() {
      this.$emit('animationEnd')
    },
  },
}
</script>

<style lang="scss" scoped>
.splash-loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
  width: 100vw;
  width: 100dvw;
  height: var(--viewport-height);
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .logo {
    display: block;
    width: 50vw;
    max-width: 256px;
    min-width: 128px;
    max-height: 80vh;
  }
}
</style>
